export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";